/* TODO: have this be unit tested */

import React from 'react';
import PropTypes from 'prop-types';
import { formatDate } from '~/utils';
import { DATE_FORMAT } from '~/utils/consts';

const TableCellDate = ({
  value,
  format: f,
  emptyValue,
}) => (
  <div>{formatDate(value, f, emptyValue)}</div>
);

TableCellDate.propTypes = {
  value: PropTypes.string.isRequired,
  format: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      in: PropTypes.string,
      out: PropTypes.string,
    }),
  ]),
  emptyValue: PropTypes.string,
};

TableCellDate.defaultProps = {
  format: DATE_FORMAT,
  emptyValue: '',
};

export default TableCellDate;
